import React, { useState } from 'react';
import Navigation from '../components/Navigation';
import BookingSystem from '../components/BookingSystem';
import MassageRecommendation from '../components/MassageRecommendation';
import { Sparkles } from 'lucide-react';

export default function Booking() {
  const [showRecommendation, setShowRecommendation] = useState(false);
  const [preSelectedService, setPreSelectedService] = useState(null);

  const handleServiceSelect = (service) => {
    setPreSelectedService(service);
  };

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      
      <div className="pt-16">
        {/* Hero Section with Help Button */}
        <div className="bg-gradient-to-br from-teal-50 to-cyan-50 py-12">
          <div className="max-w-4xl mx-auto px-4 text-center">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">Book Your Massage</h1>
            <p className="text-xl text-gray-600 mb-6">
              Not sure which massage is right for you?
            </p>
            <button
              onClick={() => setShowRecommendation(true)}
              className="inline-flex items-center space-x-2 bg-gradient-to-r from-teal-600 to-cyan-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:from-teal-700 hover:to-cyan-700 transition shadow-lg hover:shadow-xl"
            >
              <Sparkles size={24} />
              <span>Help Me Choose the Perfect Massage</span>
            </button>
            <p className="text-sm text-gray-500 mt-3">
              Answer a few quick questions for personalized recommendations
            </p>
          </div>
        </div>

        {/* Booking Form */}
        <BookingSystem preSelectedService={preSelectedService} />
      </div>

      {/* Recommendation Modal */}
      {showRecommendation && (
        <MassageRecommendation
          onSelect={handleServiceSelect}
          onClose={() => setShowRecommendation(false)}
        />
      )}
    </div>
  );
}